import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import Text from '@zenbusiness/common-components/Text';

import * as Styled from './ProfileInfo.style';

const ProfileInformation = () => {
  const { obo } = useAuthentication();
  const {
    email = '',
    firstName = '',
    lastName = '',
    accountEmail = ''
  } = useIdentity();
  const isObo = !!obo;
  const profileEmail = isObo ? email : accountEmail;
  const profileName = `${firstName} ${lastName}`;

  return (
    <Styled.Root className="profile-info">
      <Text bold size="lg">
        <Styled.TruncatedText>
          {isObo ? `On behalf of ${profileName}` : profileName}
        </Styled.TruncatedText>
      </Text>
      <Styled.Email>
        {profileEmail}
      </Styled.Email>
    </Styled.Root>
  );
};

export default ProfileInformation;
